import { connect } from "react-redux";

const ExportRowExportButton = ({
  selectedDestination,
  handleClick,
  isDisabled,
}) => {
  const hasValidSelectedDestination = () => {
    return (
      typeof selectedDestination === "string" &&
      selectedDestination.length > 0 &&
      selectedDestination !== "default"
    );
  };
  return (
    <button
      onClick={() => handleClick()}
      disabled={
        !hasValidSelectedDestination() || isDisabled
      }
      className={
        hasValidSelectedDestination()
          ? ""
          : "disabled"
      }
    >
      Export
    </button>
  );
};

const mapStateToProps = (state) => ({
  selectedDestination: state.genericExportOptions.selectedDestination,
});

export const ConnectedExportRowExportButton = connect(mapStateToProps)(
  ExportRowExportButton
);

export default ConnectedExportRowExportButton;
